import { useContact } from "../../../../hooks/useContact";
import { Notes } from "../../../Molecules/Notes";
import { useCreateContactNoteMutation } from "../../../../services/api/contactsApi/contact";

/** `contactId` overrides the route param, e.g. when rendered in the notes drawer */
export function ContactNotes({ contactId }: { contactId?: number } = {}) {
  const { data: contact } = useContact(contactId);

  const [postNewNote, { isLoading: isPostingNote }] = useCreateContactNoteMutation();

  async function onNewNote(content: string, mentionedUsers: string[], attachments: File[], syncAttachments: boolean) {
    // Create the note
    await postNewNote({
      organisationId: contact.organisationId,
      contactId: contact.id,
      content,
      mentionedUsers,
      attachments,
      syncAttachments,
    });
  }

  if (!contact) return null;

  return (
    <div>
      <Notes
        notes={ contact.notes }
        loading={ isPostingNote }
        enableNewNote
        onSave={ onNewNote }
      />
    </div>
  );
}
